var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(false && !_vm.$props.noBack)?_c('n-button',{staticStyle:{"padding":"0.25em"},attrs:{"type":"primary","id":"backButton"},on:{"click":function($event){return _vm.back()}}},[_vm._v(_vm._s(_vm.$t('back')))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }